import {useGlobalStrings} from '@helios/shared/providers/global-strings'
import CompanySize from '@helios/shared/types/company-size'

export const getCompanySizeOptions = () =>
    Object.values(CompanySize).map((value) => {
        const globalStrings = useGlobalStrings()

        switch (value) {
            case CompanySize.SoleTrader: {
                return {
                    label: globalStrings.sole_trader,
                    value,
                }
            }

            case CompanySize.Size_1: {
                return {
                    label: `${value} ${globalStrings.employee}`,
                    value,
                }
            }

            default: {
                return {
                    label: `${value} ${globalStrings.employees}`,
                    value,
                }
            }
        }
    })
